import AttachFileIcon from "@mui/icons-material/AttachFile";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { ASSISTANT_ATTACHMENT_ACCEPT } from "ai-assistant/attachments/assistant-attachment-policy";
import React from "react";

interface AttachFilesButtonProps {
  disabled?: boolean;
  onFiles: (files: File[]) => void;
}

/**
 * Opens the file picker for the assistant's composer (#6504).
 *
 * The picker offers the types the assistant can read. It is a hint, not the check: a user can
 * still choose "All files", which is why the files chosen are checked again before they upload.
 */
export default function AttachFilesButton({ disabled, onFiles }: Readonly<AttachFilesButtonProps>) {
  const inputRef = React.useRef<HTMLInputElement>(null);

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const files = Array.from(event.target.files ?? []);
    // Emptied so choosing the same file again - after removing it, say - is still a change.
    event.target.value = "";
    if (files.length > 0) onFiles(files);
  }

  return (
    <>
      <Tooltip title="Attach files">
        <span>
          <IconButton
            aria-label="Attach files"
            color="primary"
            disabled={disabled}
            onClick={() => inputRef.current?.click()}
          >
            <AttachFileIcon />
          </IconButton>
        </span>
      </Tooltip>
      <input
        ref={inputRef}
        type="file"
        multiple
        hidden
        accept={ASSISTANT_ATTACHMENT_ACCEPT}
        data-testid="assistant-attachment-input"
        onChange={handleChange}
      />
    </>
  );
}
